document.addEventListener('DOMContentLoaded', function () {
  $(document).on('shopify:section:load', initSliders);

  initSliders();

  function initSliders() {
    console.log('initSliders func handle')
    console.log('child-collection-carousel', $('.child-collection-carousel'))
    $('.child-collection-carousel').each(function (index) {
      var $carousel = $(this);
      var $progressBar = $('.child-collection__pagination--progress');
      var carouselOptions = {
        infinite: false,
        accessibility: false, // Disable accessibility features 
        slidesToShow: 1,
        slidesToScroll: 1,
        swipeToSlide: true,
        variableWidth: true,
        arrows: false,
        dots: false,
        onInit: updateProgress,
        onReInit: updateProgress,
        onAfterChange: updateProgress

      };
      function updateProgress(event, slick, currentSlide) {
        console.log(currentSlide, 'currentSlide')
        currentSlide = currentSlide || 0;
        var progress = ((currentSlide + slick.options.slidesToShow) / slick.slideCount) * 100;
        console.log($progressBar, 'progress')
        $progressBar.css('width', `${Math.min(progress, 100)}%`);
      }

      setTimeout(function () {
        // Wrap the initialization code in a try-catch block to handle any potential errors
        try {
          $carousel
            .on('init', updateProgress)
            .on('afterChange', updateProgress);
          $carousel.slick(carouselOptions);
        } catch (error) {
          initSliders();
          console.error('Error initializing carousel:', error);
        }

        // Manually trigger AOS refresh and Lazy Load refresh
        try {
          AOS.refresh();
        } catch (e) {
          console.log('e', e)
        }
      }, index * 50); // Adjust delay as necessary

    })
  }


  console.log('initSliders', initSliders)
  window.initSliders = initSliders;



});